import { Component } from "react";
import JWTTokenService from "../core_library/authentication/jwt_token_service";
import AuthWebService from "../service/auth_web_service";
import Cookies from 'js-cookie';

class AuthBloc extends Component {
  static resetAuthData(){
    // Clear localStorage and sessionStorage
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.removeItem("isAuthenticate");
    sessionStorage.removeItem("authenticateToken");
    sessionStorage.removeItem("isLogin");
    localStorage.removeItem("dataUser");
    localStorage.removeItem("selectedBank");
    localStorage.removeItem("userSettings");
    Cookies.remove("auth0.e1DUVicrINCjLU6hyGyWok9IcTGqr6rc.is.authenticated")    
  }
  static isHeadOfBanca(id) {
    return id == "FWD_HEAD_OF_BANCA" ? true : false;
  }

  static isSalePerson(mapCode) {
    return mapCode == "SalesP" ? true : false;
  }

  static async getAuthAccessToken(){
    let response = await AuthWebService.getAuthAccessToken();

    if (response.success) {      
    }

    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

    static async login(token,idToken) {
    let response = await AuthWebService.login(
      token,
      idToken    
    );

    if (response.success) {
      localStorage.setItem("dataUser", JSON.stringify(response.data));
    }

    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  static async resetPassword(userName, password) {
    let response = await AuthWebService.resetPassword(userName, password);

    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  static async changePassword(userName, oldPassword, password) {
    let response = await AuthWebService.changePassword(
      userName,
      oldPassword,
      password
    );

    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  static async logOutPortal() {
    let response = await AuthWebService.logOutPortal();
    if (response.success == true) {
      localStorage.removeItem("dataUser");
      localStorage.removeItem("selectedBank");
      localStorage.removeItem("userSettings");
    }
    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  static getDataUser() {
    return localStorage.getItem("dataUser")
      ? JSON.parse(localStorage.getItem("dataUser"))
      : null;
  }

  static setGodMode(value) {
    localStorage.setItem("godMode", value);
  }

  static getGodMode() {
    return localStorage.getItem("godMode");
  }

  static async currentAccessToken() {
    let token = "";
    let refreshToken = "";

    let dataUser = JSON.parse(localStorage.getItem("dataUser"));
    if (dataUser) {
      token = dataUser.accessToken;
      refreshToken = dataUser.refreshToken;
    }

    return token;
  }

  static async checkSession() {
    let token = "";
    let refreshToken = "";

    let dataUser = JSON.parse(localStorage.getItem("dataUser"));
    if (dataUser) {
      token = dataUser.accessToken;
      refreshToken = dataUser.refreshToken;
    }

    if (token) {
      // Check Expirity of the token
      let isTokenValid = await JWTTokenService.isValid(token);

      if (!isTokenValid) {
        /* // Do Renew Token
        let resp = await AuthWebService.renewToken(refreshToken);

        //console.log(resp);

        if (resp.success) {
          localStorage.setItem("dataUser", JSON.stringify(resp.data));
          dataUser = JSON.parse(localStorage.getItem("dataUser"));
        } else {
          localStorage.removeItem("dataUser");
          dataUser = "";
        } */
       dataUser = ""
      }
    }
    return dataUser;
  }
}
export default AuthBloc;
